// =====================================================================
// RECUPERAR MI CUENTA · reglas de pantalla · ESTABILIDAD F6 · Parte E
// =====================================================================
// Funciones puras, sin React, para probarlas en Node. Las pantallas
// (`RecuperarMiCuenta`, `RecuperacionNoFuiYo`) las importan de aquí, y
// `auth.jsx` las usa para saber qué pintar antes que la aplicación.
//
// Las dos ligas que atiende (tabla `src/correo/destinosIr.json`):
//   · `/app?ir=recuperar`                       la pantalla «Recuperar mi cuenta»;
//     con `&s=<seguimiento>&n=<petición>&c=<empresa>` abre esa petición.
//   · `/app?ir=recuperar-no-fui-yo&t=…&c=…`  el botón del aviso a los contactos.

const CLAVE_PETICION = 'tego_recuperacion';

/** Lee `?ir=recuperar` (con o sin petición). */
export function enlaceDeRecuperacion(busqueda) {
  try {
    const q = new URLSearchParams(busqueda);
    if (q.get('ir') !== 'recuperar') return null;
    const s = (q.get('s') || '').trim();
    const n = Number(q.get('n'));
    const c = Number(q.get('c'));
    if (/^[A-Za-z0-9_-]{20,200}$/.test(s) && Number.isInteger(n) && n > 0
        && Number.isInteger(c) && c > 0) {
      return { peticion: { seguimiento: s, solicitud: n, empresa: c } };
    }
    return { peticion: null };
  } catch {
    return null;
  }
}

/** Lee `?ir=recuperar-no-fui-yo&t=…&c=…`. */
export function enlaceNoFuiYoRecuperacion(busqueda) {
  try {
    const q = new URLSearchParams(busqueda);
    if (q.get('ir') !== 'recuperar-no-fui-yo') return null;
    const t = (q.get('t') || '').trim();
    const c = Number(q.get('c'));
    if (!/^[A-Za-z0-9_-]{20,200}$/.test(t) || !Number.isInteger(c) || c <= 0) return null;
    return { token: t, empresa: c };
  } catch {
    return null;
  }
}

/** La liga de seguimiento de una petición, para guardarla o copiarla. */
export function ligaDeSeguimiento(origen, p) {
  return `${origen}/app?ir=recuperar&s=${encodeURIComponent(p.seguimiento)}&n=${p.solicitud}&c=${p.empresa}`;
}

// La petición en curso se recuerda EN ESTA PESTAÑA (sessionStorage): es
// una comodidad para recargar sin perder el paso, no el único lugar donde
// vive (el correo «Recibimos tu petición» trae la liga).
export function recordarPeticion(p) {
  try { sessionStorage.setItem(CLAVE_PETICION, JSON.stringify(p)); } catch { /* modo privado */ }
}
export function peticionRecordada() {
  try {
    const p = JSON.parse(sessionStorage.getItem(CLAVE_PETICION) || 'null');
    return p && p.seguimiento && p.solicitud && p.empresa ? p : null;
  } catch {
    return null;
  }
}

// ---------------------------------------------------------------------
// Formatos que se autocorrigen mientras se escribe (Doctrina 2 §8)
// ---------------------------------------------------------------------
export function limpiarRfc(texto) {
  return (texto || '').replace(/[\s-]/g, '').toUpperCase().slice(0, 13);
}
export function rfcValido(rfc) {
  return /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(rfc || '');
}
export function limpiarCurp(texto) {
  return (texto || '').replace(/\s/g, '').toUpperCase().slice(0, 18);
}
export function curpValida(curp) {
  return /^[A-Z]{4}\d{6}[HMX][A-Z]{5}[A-Z0-9]\d$/.test(curp || '');
}
export function correoValido(correo) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((correo || '').trim());
}

/** Qué falta para poder pulsar «Empezar», en palabras (Doctrina 2 §8). */
export function faltaParaEmpezar({ rfc, correo }) {
  const falta = [];
  if (!rfcValido(rfc)) falta.push('el RFC de la empresa (12 o 13 caracteres)');
  if (!correoValido(correo)) falta.push('un correo donde recibir noticias');
  return falta;
}

/** Los pasos del asistente según el camino, con su nombre corto. */
export function pasosDelCamino(camino) {
  return camino === 'VIDEOLLAMADA'
    ? ['Empezar', 'Constancia fiscal', 'CURP', 'Espera y revisión']
    : ['Empezar', 'e.firma', 'Constancia fiscal', 'CURP', 'Espera y revisión'];
}

/** En qué paso del asistente va una petición, según su estado del servidor. */
export function pasoDelEstado(estado) {
  if (!estado) return 0;
  const orden = pasosDelCamino(estado.camino);
  const mapa = { EFIRMA_VERIFICADA: 'e.firma', CSF_VERIFICADA: 'Constancia fiscal', CURP_VERIFICADA: 'CURP' };
  const sig = estado.siguiente;
  if (!sig || !mapa[sig]) return orden.length - 1;
  return orden.indexOf(mapa[sig]);
}

/** «Faltan 71 h 12 min» — o null si ya pasó. */
export function faltaParaLaRevision(esperaHastaIso, ahora = Date.now()) {
  const fin = Date.parse(esperaHastaIso || '');
  if (!Number.isFinite(fin)) return null;
  const ms = fin - ahora;
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  return `Faltan ${h} h ${m} min`;
}
